import { cloneDeep } from "lodash";
import { AnyAction } from "redux";
import { FETCH_DEPENDENTE_END, FETCH_DEPENDENTE_RESULTS, FETCH_DEPENDENTE_START, FETCH_RESULTS, FETCH_SCHEDULING_END, FETCH_SCHEDULING_START } from "../actions/collaboratorInitial";
import { SchedulingService } from "./../../core/http/service/SchedulingService";
import DependentesListaModel from "../../models/dependente/DependentesListaModel";

interface IcollaboratorInitial {
  scheduling: SchedulingService<any>[];
  dependenteColaborador: DependentesListaModel[];
  isLoading: boolean;
}

const initialState: IcollaboratorInitial = {
  scheduling: [],
  dependenteColaborador: [],
  isLoading: false,
};

export const CollaboratorInitial = (
  state = initialState,
  action: AnyAction
): IcollaboratorInitial => {
  switch (action.type) {
    case FETCH_DEPENDENTE_START:
    case FETCH_SCHEDULING_START:
      return {
        ...state,
        isLoading: true,
      };
    case FETCH_DEPENDENTE_END:
      return {
        ...cloneDeep(state),
        dependenteColaborador: action.dependenteColaborador,
        isLoading: false,
      };
    case FETCH_SCHEDULING_END:
      return {
        ...cloneDeep(state),
        scheduling: action.scheduling,
        isLoading: false,
      };
    case FETCH_RESULTS:
      return {
        ...cloneDeep(state),
        scheduling: action.scheduling,
        dependenteColaborador: action.dependenteColaborador,
      };
    case FETCH_DEPENDENTE_RESULTS:
      return {
        ...cloneDeep(state),
        dependenteColaborador: action.dependenteColaborador,
      };
    default:
      return state;
  }
};